import { Link, Navigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { AssistantTab } from '../components/whatsapp/AssistantTab';
import { WhatsAppAccountTab } from '../components/whatsapp/WhatsAppAccountTab';
import { useWhatsApp } from '../whatsapp/WhatsAppContext';

export type WhatsAppSettingsTab = 'whatsapp' | 'assistant';

const tabClass = (active: boolean) =>
  `flex h-10 items-center rounded-full border px-[18px] text-sm no-underline ${
    active
      ? 'border-primary bg-primary font-semibold text-white'
      : 'border-stone-200 bg-white font-medium text-stone-600 hover:bg-stone-50'
  }`;

export const WhatsAppSettings = ({ tab }: { tab: WhatsAppSettingsTab }) => {
  const { loaded, enabled } = useWhatsApp();
  if (loaded && !enabled) return <Navigate to="/home" replace />;

  return (
    <div className="flex min-h-screen w-full flex-col bg-stone-50 p-6 font-geist text-stone-800">
      <Navbar showLogout={true} />
      <main className="mx-auto flex w-full max-w-[880px] flex-1 flex-col gap-5 py-6">
        <Link
          to="/whatsapp"
          className="inline-flex h-10 items-center gap-1.5 self-start text-sm font-semibold text-primary no-underline"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Volver a la bandeja
        </Link>

        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="m-0 text-[30px] font-bold tracking-tight text-stone-900">Configuración de WhatsApp</h1>
            <p className="mt-1 text-[15px] text-stone-600">Conecta tu número y define qué responde el asistente.</p>
          </div>
          <nav aria-label="Secciones de configuración" className="flex flex-wrap gap-1.5">
            <Link to="/whatsapp/settings" aria-current={tab === 'whatsapp' ? 'page' : undefined} className={tabClass(tab === 'whatsapp')}>
              WhatsApp
            </Link>
            <Link to="/whatsapp/settings/assistant" aria-current={tab === 'assistant' ? 'page' : undefined} className={tabClass(tab === 'assistant')}>
              Asistente
            </Link>
          </nav>
        </div>

        {tab === 'assistant' ? <AssistantTab /> : <WhatsAppAccountTab />}
      </main>
    </div>
  );
};
